var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 201.289,
    height: 200,
    viewBox: "0 0 201.289 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 72.45,
    y: 84.586,
    width: 105.532,
    height: 91.794,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 23.021,
    y: 84.516,
    width: 89.196,
    height: 91.844,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 87.245,
    y: 25.793,
    width: 80.424,
    height: 80.421,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 33.357,
    y: 25.765,
    width: 80.403,
    height: 80.414,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 128.555,
    y: 73.409,
    width: 59.709,
    height: 86.953,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 12.759,
    y: 73.491,
    width: 59.734,
    height: 86.88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 74.171,
    y: 72.327,
    width: 50.452,
    height: 37.339,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.536)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.536)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.644,
    cy: 100,
    rx: 100.644,
    ry: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.644,
    cy: 100,
    rx: 98.644,
    ry: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.778 40.765)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.76, -40.76)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-59.859-358.279c-.115,5.873-2.643,11.016-6.275,15.734-3.832,4.974-8.651,8.864-13.682,12.513-5.43,3.933-10.908,7.792-16.349,11.712a2.108,2.108,0,0,1-2.751.149c-7.742-5.522-15.686-10.78-22.979-16.9-5.552-4.66-10.229-10.063-12.5-17.139a21.02,21.02,0,0,1,16.906-27.115c6.958-.983,12.51,1.791,17.011,6.948a27.375,27.375,0,0,1,2.193,2.906c.5.75.787.787,1.3,0a25.244,25.244,0,0,1,5.755-6.262c8.154-6.285,18.825-4.221,25.317,2.477A21.264,21.264,0,0,1-59.859-358.279Zm-4.886-.172a15.646,15.646,0,0,0-4.379-11.185c-5.092-5.532-13.371-7.12-19.636-1.913a28.538,28.538,0,0,0-4.951,5.812,4.555,4.555,0,0,1-7.654.216c-.733-.916-1.335-1.933-2.061-2.852-3.1-3.95-6.927-6.539-12.192-6.356-.456.017-1.088-.091-1.271.328-.213.483.439.72.733,1.038,4.88,5.224,7.012,11.327,5.792,18.444-.963,5.646-3.974,10.249-7.671,14.463-1.176,1.341-1.206,1.324.139,2.409,6.272,5.042,12.909,9.594,19.43,14.3a1.306,1.306,0,0,0,1.784-.1c5.1-3.68,10.239-7.292,15.311-11,5.133-3.751,9.884-7.914,13.344-13.341A18.059,18.059,0,0,0-64.745-358.451Zm-50.086-.432a16.339,16.339,0,0,0-6.65-12.713,1.685,1.685,0,0,0-2.335-.024,16.332,16.332,0,0,0-6.1,17.494c1.23,4.3,3.751,7.813,6.708,11.071.534.588.8.314,1.179-.111a38.2,38.2,0,0,0,4.464-6.062A19.1,19.1,0,0,0-114.832-358.883Z",
    transform: "translate(222.84 479.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.76, -40.76)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-145.34-358.394c-.034,5.1,2.288,9.259,5.309,13.125,3.869,4.944,8.82,8.688,13.821,12.364,4.217,3.1,8.516,6.1,12.753,9.175a1.348,1.348,0,0,0,1.869.04c5.407-3.825,10.813-7.643,16.082-11.651.97-.737,1.646-.835,2.376.189a3.838,3.838,0,0,0,.622.615c2.153,1.906,1.811,1.612-.213,3.139-5.951,4.5-12.1,8.725-18.17,13.05a2.261,2.261,0,0,1-2.97.165c-7.779-5.616-15.842-10.854-23.158-17.082-5.15-4.383-9.492-9.455-11.912-15.936a21.062,21.062,0,0,1,16.717-28.091c7.1-.956,12.618,2.018,17.126,7.259a31.918,31.918,0,0,1,2.038,2.71c.439.642.7.649,1.142-.02a25.006,25.006,0,0,1,6.863-7.086,18.865,18.865,0,0,1,10.063-3.1c.372-.013.862-.068,1,.331.132.355-.324.531-.574.73a19.961,19.961,0,0,0-2.849,2.649,9.171,9.171,0,0,1-3.244,2.467,17.65,17.65,0,0,0-7.265,6.765c-.906,1.4-1.9,2.673-3.69,2.974a4.481,4.481,0,0,1-4.7-1.96,32.639,32.639,0,0,0-4.717-5.694c-6.211-5.5-14.852-3.869-19.934,1.69A15.718,15.718,0,0,0-145.34-358.394Z",
    transform: "translate(188.26 479.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.76, -40.76)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-80.589-371.147a25.214,25.214,0,0,1-25.2,25.185,25.429,25.429,0,0,1-25.229-25.124,25.252,25.252,0,0,1,25.229-25.3A25.047,25.047,0,0,1-80.589-371.147ZM-105.71-391.5a20.254,20.254,0,0,0-20.417,20.154,20.39,20.39,0,0,0,20.143,20.485A20.41,20.41,0,0,0-85.36-371.13,20.262,20.262,0,0,0-105.71-391.5Z",
    transform: "translate(233.26 437.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.76, -40.76)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-147.178-371.194a25.161,25.161,0,0,1,25.638-25.2A25.27,25.27,0,0,1-96.78-371a25.134,25.134,0,0,1-25.141,25.023A25.063,25.063,0,0,1-147.178-371.194Zm25.3-20.289a20.148,20.148,0,0,0-20.512,20.312,20.306,20.306,0,0,0,20.8,20.333,20.392,20.392,0,0,0,19.951-20.68A20.269,20.269,0,0,0-121.874-391.483Z",
    transform: "translate(195.54 437.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.76, -40.76)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-93.991-343c0-4.4.081-8.8-.017-13.2a22.056,22.056,0,0,0-17.923-21.6,26.657,26.657,0,0,0-6-.422c-.308,0-.76.145-.848-.3-.064-.314.318-.46.551-.618a27.981,27.981,0,0,0,3.8-3.089,2.119,2.119,0,0,1,1.95-.571,26.65,26.65,0,0,1,23.09,23.286,29.877,29.877,0,0,1,.294,3.883q.041,13.386.014,26.773c0,1.889-.841,2.93-2.328,2.974-1.551.047-2.514-1.011-2.541-2.916-.037-2.683-.014-5.366-.014-8.046V-343Z",
    transform: "translate(262.34 471.24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.76, -40.76)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-153.271-343.377c0-4.44-.014-8.881,0-13.321a26.88,26.88,0,0,1,22.6-26.026,3.467,3.467,0,0,1,3.562,1.115,16.082,16.082,0,0,0,2.842,2.267c.291.213.821.385.71.78-.145.507-.72.294-1.1.284a24.134,24.134,0,0,0-7.819.933c-8.664,2.74-13.8,8.644-15.615,17.5a19.838,19.838,0,0,0-.29,4q.01,13.255.01,26.513a4.738,4.738,0,0,1-.26,1.855,2.225,2.225,0,0,1-2.322,1.551,2.2,2.2,0,0,1-2.163-1.761,5.475,5.475,0,0,1-.142-1.49q-.01-7.1,0-14.2Z",
    transform: "translate(181.04 471.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.76, -40.76)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-114.569-375.981a26.58,26.58,0,0,0-4.643.321,6.25,6.25,0,0,1-4.336-.638,23.082,23.082,0,0,0-10.29-1.909c-.389.013-.977.226-1.132-.226-.156-.47.456-.629.774-.848a31.324,31.324,0,0,0,3.606-2.933,1.81,1.81,0,0,1,1.568-.6,27.159,27.159,0,0,1,14.21,6.174A.549.549,0,0,1-114.569-375.981Z",
    transform: "translate(224.17 470.16)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/Love.c98605cf537a31f3d24f584c185920dc.svg";
export { ForwardRef as ReactComponent };